import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { API } from "../../shared/api/Api";
import { selectUserInformations } from "../../features/authSlice";

const PlacementTestLinkRedirectPage = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const user = useSelector(selectUserInformations);

  useEffect(() => {
    const resolve = async () => {
      const headers = user?.token ? { Authorization: `Bearer ${user.token}` } : {};
      const { data } = await axios.get(`${API.PlacementTests.resolveLink}/${uuid}`, { headers });
      const payload = data.data || {};

      if (payload.action === "login_required") {
        navigate("/login");
        return;
      }

      if (payload.action === "go_to_exam") {
        window.location.href = `${API.examsAppUrl}/exam/${payload.exam_code}?token=${user.token}`;
        return;
      }

      navigate(`/placement-tests/${payload.placement_test_id}/payment`);
    };

    resolve();
  }, [uuid, navigate, user]);

  return <div className="py-12 text-center text-gray-600">Redirecting...</div>;
};

export default PlacementTestLinkRedirectPage;
